export default "__VITE_ASSET__tOkEbfB8__"